import type { ICommand } from "@uiw/react-md-editor/nohighlight";
import { AtSign, MessageSquareShare, Paperclip } from "lucide-react";
import { ToolbarButton, ToolbarDivider } from "./ToolbarButton";
import { SavedRepliesMenu, SlashCommandsMenu } from "./ToolbarMenus";
import {
	FORMAT_ACTIONS,
	LIST_ACTIONS,
	actionTooltip,
	type ToolbarAction,
} from "./markdown-commands";

interface Props {
	onCommand: (command: ICommand) => void;
	onInsert: (text: string, options?: { block?: boolean }) => void;
	onAttach: () => void;
	onMenuClose: () => void;
	getText: () => string;
}

export function MarkdownToolbar({
	onCommand,
	onInsert,
	onAttach,
	onMenuClose,
	getText,
}: Props) {
	const renderAction = (action: ToolbarAction) => (
		<ToolbarButton
			key={action.label}
			icon={action.icon}
			label={action.label}
			tooltip={actionTooltip(action)}
			onClick={() => onCommand(action.command)}
		/>
	);

	return (
		<div
			role="toolbar"
			aria-label="Formatting tools"
			className="flex flex-wrap items-center justify-end py-1"
			// Keep the textarea selection while clicking tools.
			onMouseDown={(e) => e.preventDefault()}
		>
			{FORMAT_ACTIONS.map(renderAction)}
			<ToolbarDivider />
			{LIST_ACTIONS.map(renderAction)}
			<ToolbarDivider />
			<ToolbarButton icon={Paperclip} label="Attach files" onClick={onAttach} />
			<ToolbarButton icon={AtSign} label="Mention" onClick={() => onInsert("@")} />
			<ToolbarButton
				icon={MessageSquareShare}
				label="Reference a task or ticket"
				onClick={() => onInsert("#")}
			/>
			<SavedRepliesMenu
				onInsert={onInsert}
				onClose={onMenuClose}
				getText={getText}
			/>
			<SlashCommandsMenu onInsert={onInsert} onClose={onMenuClose} />
		</div>
	);
}
